const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'A jármű forgalmi engedélye',
	'vehicleRegistrationDocument.description':
		'Töltsön fel jól látható fényképeket a forgalmi engedély kért oldalairól.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'A forgalmi engedély eleje',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Készítsen jól látható fényképet a forgalmi engedély elejéről.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'A forgalmi engedély eleje',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'A forgalmi engedély eleje - példa',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'A forgalmi engedély eleje',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title': 'A forgalmi engedély hátulja',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Készítsen jól látható fényképet a forgalmi engedély hátuljáról.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline': 'A forgalmi engedély hátulja',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'A forgalmi engedély hátulja - példa',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'A forgalmi engedély hátulja',
	'vehicleRegistrationDocument.validationHeadline': 'Hiányzó fényképek',
	'vehicleRegistrationDocument.validationDescription': 'Adja hozzá a következő fényképeket:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Fényképezze le a forgalmi engedélyt',
	'review.stepDescription.vehicleRegistrationDocument': 'A jármű forgalmi engedélye',
	'loader.loading': 'Adatok betöltése folyamatban…',
	'loader.error': 'A folyamatot nem sikerült betölteni. Kérlek, próbáld újra később…',
	'connectionError.title': 'Kapcsolati hiba',
	'connectionError.description': 'Kapcsolati hiba. Kérjük töltse fel újra a fotókat.',
	'mainError.tryAgain': 'Kérjük, próbálja újra',
	'landing.headline.policyCheck': 'Üdvözöljük',
	'landing.paragraph':
		'Már csak két lépésre van attól, hogy elvégezze a digitáls gépjármű szemléjét, melyre két órája van',
	'landing.stepDescription.fourAdditionalPictures': 'Készítse el a szükséges fényképeket',
	'landing.stepDescription.fourDiagonalPerspectives': 'Készítse el a szükséges fényképeket',
	'landing.stepDescription.feedback': 'Véleményezze a  folyamatunkat',
	'landing.termsAndConditionsLinkDescription':
		'"Start" gomb megnyomásával elfogadom az <tclink>Adatkezelési tájékoztatót és a Felhasználási feltételeket</tclink>.',
	termsAndConditionsLink: 'A továbblépéssel elfogadja az Általános szerződési feltételeinket',
	'button.start': 'START',
	'landing.aboutPolicyCheck': 'Vissza',
	'landing.additional-informations-section.title':
		'Gépkocsijának szemléje előtt ellenőrizze, hogy:',
	'landing.additional-informations-section.text': ' ',
	'landing.additional-informations-section.text.motorbike': ' ',
	'chooseLang.headline': 'Válassza ki a nyelvet',
	'button.close': 'Bezár',
	'blockedByDevice.headline': 'A folyamat asztali számítógépen nem indítható el',
	'blockedByDevice.description':
		'<br> A folyamat során a rendszer mobil eszköz használatát várja el. A folytatáshoz kérjük, váltson mobil eszközre',
	'tutorialModal.headline.first.policyCheck': ' ',
	'tutorialModal.paragraph.first.policyCheck': ' ',
	'tutorialModal.paragraph.second': ' ',
	'button.ok': 'Ok',
	'button.prev': 'Vissza',

	'vehicleImages.overviewPhotos': 'Gépjármű szemle',
	'vehicleImages.overviewPhotos.subtitle': ' ',
	'vehicleImages.description':
		'Készítsen fotókat a gépjárműről minden szögből. A rendszámnak minden képen jól láthatónak kell lennie.',
	'vehicleImages.description.motorbike': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'A gépjármű bal első része átlósan',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'A gépjármű bal hátsó része átlósan',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'A gépjármű jobb hátsó része átlósan',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'A gépjármű jobb első része átlósan',
	'button.next': 'Következő',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Példa',
	'imageRecognitionMismatchModal.headline': 'Kérjük várjon amíg a fotók helyességét ellenőrizzük',
	'button.continue': 'Folytatás',
	'button.backchangeImage': 'Készítsen új képet',
	'completeVehicleImagesModal.headline': 'Hiányzó fotó',
	'completeVehicleImagesModal.description': 'Kérjük, csatolja a következő fényképeket:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'A gépjármű bal első része átlósan',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'A gépjármű bal hátsó része átlósan',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'A gépjármű jobb első része átlósan',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'A gépjármű jobb hátsó része átlósan',
	'vehicleImages.leftFrontOverview': 'A gépjármű bal első része átlósan',
	'vehicleImages.leftRearOverview': 'A gépjármű bal hátsó része átlósan',
	'vehicleImages.rightRearOverview': 'A gépjármű jobb hátsó része átlósan',
	'vehicleImages.rightFrontOverview': 'A gépjármű jobb első része átlósan',
	'button.changeImage': 'KÉSZÍTSEN ÚJ KÉPET',
	'button.deleteImage': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'(PÉLDA) A gépjármű bal első része átlósan ',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'(PÉLDA) A gépjármű bal hátsó része átlósan',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'(PÉLDA) A gépjármű jobb hátsó része átlósan',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'(PÉLDA) A gépjármű jobb első része átlósan',
	'fourPerspectivesExampleModal.button.close': 'OK',

	'fourAdditionalPictures.title': 'További információ',
	'fourAdditionalPictures.overallDashboard.title': 'Műszerfal',
	'fourAdditionalPictures.overallDashboard.description':
		'Készítsen egy fotót a teljes műszerfalról',
	'fourAdditionalPictures.mileage.title': 'Kilométeróra állása',
	'dashboardMileage.dashboard.paragraph':
		'Kérjük készítsen fotót a gépjármű kilométerórájáról úgy, hogy az aktuális óraállás jól látható legyen. Ha digitális kijelzője van, kérjük indítsa be a járművet.',
	'dashboardMileage.paragraph.first': 'Írja be az aktuális kilométeróra állást',
	'dashboardMileage.placeholder': 'Kilométeróra állás',
	'dashboardMileage.input.error': 'Kérjük rögzítse a jármű aktuális kilométeróra állását!',
	'fourAdditionalPictures.windshield.title': 'Szélvédő',
	'fourAdditionalPictures.windshield.description':
		'Kérjük készítsen fotót a gépjármű szélvédőjéről, jól láthatóan.',
	'fourAdditionalPictures.vin.title': 'Alvázszám',
	'fourAdditionalPictures.vin.description': 'Kérjük készítsen fotót a gépjármű alvázszámáról.',
	'mileageModal.headline': 'Kérjük, ellenőrizze a megadott kilóméteróra állás helyességét!',
	'mileageModal.paragraph':
		'A fotón látható kilométeróra állás nem egyezik az Ön által megadott értékkel. Módosítsa az értéket, vagy erősítse meg a fotón látható kilométeróra állás helyességét!',
	'mileageModal.insertedMileagePlaceholder': 'Megadott kilométeróra állás',
	'mileageModal.pictureMileage': 'A képen látható kilométeróra állás',
	'button.reverse': 'A képen látható érték elfogadása',
	'button.confirm': 'Megadott érték megerősítése',
	'overallDashboardImage.title': 'Műszerfal',
	'dashboardMileage.dashboard.title': 'Kilométeróra állás',
	'windshieldImage.title': 'Szélvédő',
	'vinPicture.title': 'Alvázszámról készült fotó',
	'completeFourAdditionalPicturesModal.headline': 'Hiányzó fotók',
	'completeFourAdditionalPicturesModal.description': 'Kérjük, mellékelje a következő fényképeket:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Műszerfal',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Kilométeróra állás',
	'completeDashboardMileageModal.hasValidMileage':
		'Kérjük, írja be az aktuális kilométeróra állást',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Alvázszám',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Szélvédő',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Kérjük, így készítse el a fotót',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Kérjük, így készítse el a fotót',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Kérjük, így készítse el a fotót',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Kérjük, így készítse el a fotót',
	'fourAdditionalPicturesExampleModal.button.close': 'OK',
	'review.button.next': 'Következő',

	'feedback.headline.policyCheck': 'Az összes fotó sikeresen feltöltésre került!',
	'feedback.description': ' ',
	'feedback.rating.policyCheck': 'Hogyan értékelné az online gépjármű szemle folyamatát?',
	'feedback.yourOpinion': 'Észrevétele van? Ossza meg velünk!',
	'feedback.comment.placeholder': 'Ide írja észrevételét',
	'feedback.button.send': 'Beküldés',
	'waitForAudit.thankYou': 'A szemle folyamata lezárult! Köszönjük szépen!',
	'waitForAudit.description.damageFound': ' ',
	'thanks.headline.first': 'Köszönjük szépen a visszajelzését!',
	'thanks.paragraph.first': ' ',

	'invalidFile.size.title': 'Helytelen képméret',
	'invalidFile.size.description': 'A kép mérete nem felel meg a maximális követelményeknek.',
	'invalidFile.extension.title': 'A fájltípus nem támogatott',
	'invalidFile.extension.description':
		'A fájltípus nem támogatott. Támogatott formátumok: .jpg, .jpeg, .jfif, .heic, .heif, .png és .bmp',
	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
